import React, { useEffect } from "react";
import PropTypes from "prop-types";

import GetVideos from './../../assets/data/getVideos.json';

import VideoCard from './../video-card/video-card';

import "./video-container.scss";
import "./video-container.responsive.scss";

const VideoContainer = () => {
    let folderName;
    const [dimensions, setDimensions] = React.useState({
        height: window.innerHeight,
        width: window.innerWidth
    });

    useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
            setDimensions({
              height: window.innerHeight,
              width: window.innerWidth
            });
          }, 1000);
      
          window.addEventListener("resize", debouncedHandleResize);
      
          return _ => {
            window.removeEventListener("resize", debouncedHandleResize);
          };
    });

    function debounce(fn, ms) {
        let timer;
        return _ => {
          clearTimeout(timer);
          timer = setTimeout(_ => {
            timer = null;
            fn.apply(this, arguments);
          }, ms);
        };
    }

    if (dimensions.width > 320 && dimensions.width < 768) {
        folderName = 'mob';
    } else if (dimensions.width > 767 && dimensions.width < 1170) {
        folderName = 'ipad';
    } else if (dimensions.width > 1169 && dimensions.width < 1700) {
        folderName = '1280';
    } else {
        folderName = '1920';
    }

    return (
        <div className="video-main-cont">
            <div className="inner-cont">
                <div className="video-title">Check out the <b>3D</b>EXPERIENCE</div>
                <div className="video-subtit">A brief overview of the platform’s key applications:</div>
                {/* <VideoCard/> */}
                {/* <div className="video-card-cont deviceonly"> */}
                <div className={`${(folderName === '1920' || folderName === '1280') ? 'flexbox' : 'video-card-cont deviceonly'}`}>
                {/* <div className="flexbox"> */}
                {GetVideos.map((content, index) => {
                    console.log(content);
                    return (
                        <div>
                        <VideoCard {...content} key={index}/>
                        </div>
                    )
                })}
                </div>
                {/* {GetVideos.map((content, index) => {
                    console.log(content);
                  <VideoCard {...content} key={index}/>
                })} */}
            </div>
        </div>
      );
};

export default VideoContainer;